import React, { Component } from "react";
import { withRouter, Link, NavLink } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";

//Miscellaneous
import moment from "moment";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { getCountry } from "../../store/ducks/home/actions";
import { getUserData } from "../../store/ducks/currentUser/actions";
import { showBanner } from "../../store/ducks/banners/actions";

//Icons
import { Icon } from "@iconify/react";

let countries = [];
let langArr = [];
class PageFooter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openModal: false,
            currentCountryImage: "MY",
            currentLanguageCode: "EN",
            reloadPage: false,

            currentEvent: "",
        };
    }

    componentDidMount() {
        // const { t } = this.props;
        this.props.getCountry();
    }

    shouldComponentUpdate(nextProps, nextState) {
        // const { t } = this.props;

        if (nextProps.country_data !== undefined) {
            if (nextProps.country_data !== this.props.country_data) {
                let countryData = nextProps.country_data.country || {};
                let languageData = nextProps.country_data.language || {};
                // here

                //Clear the country array
                countries = [];
                langArr = [];

                Object.keys(countryData).map((item, i) => {
                    import(`../../assets/images/flags/${countryData[item].countryShortCode}.webp`).then((image) => {
                        if (this.props.currentUser.country_code === countryData[item].countryShortCode) {
                            this.setState({
                                currentCountryImage: image.default,
                                currentCountryShortCode: countryData[item].countryShortCode,
                                countryLoading: false,
                                currentLanguageCode: countryData[item].defaultLanguageCode.toUpperCase(),
                            });
                        }

                        if (localStorage.getItem("accessToken")) {
                            // if login & same country
                            if (this.props.currentUser.country_id === countryData[item].countryId) {
                                countries.push({
                                    image: image.default,
                                    countryId: countryData[item].countryId,
                                    countryName: countryData[item].countryName,
                                    countryCode: countryData[item].countryShortCode,
                                });
                            }
                        }
                        else {
                            countries.push({
                                image: image.default,
                                countryId: countryData[item].countryId,
                                countryName: countryData[item].countryName,
                                countryCode: countryData[item].countryShortCode,
                            });
                        }

                        this.setState({
                            loading: true,
                        });
                    });

                    return countries;
                });
                Object.keys(languageData).map((item, i) => {
                    return langArr.push({
                        languageId: languageData[item].languageId,
                        countryCode: languageData[item].countryShortCode,
                        code: languageData[item].languageCode,
                        desc: languageData[item].languageName,
                        displayLanguageName: languageData[item].displayLanguageName,
                        timezone: languageData[item].timezone,
                    });
                });
            }
        }

        if (nextProps.show_banner_data !== this.props.show_banner_data) {
            if (nextProps.show_banner_data.data.responseCode === 200) {
                if (this.state.reloadPage) {
                    window.location.reload();
                }
            } else {
                return false;
            }
        }

        return true;
    }

    imageImport = (r) => {
        let images = {};
        r.keys().map((item) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    changeCountryHandler = (event, countryCode, countryId, languageId, languageCode, timezone) => {
        event.preventDefault();

        if (this.props.currentUser.length === 0) {
            const data = {};
            data.country_code = countryCode;
            data.country_id = countryId;
            data.language_code = languageCode;
            data.language_id = languageId;
            data.time_zone = timezone;
            data.member_group_id = this.props.currentUser.member_group_id;
            // here
            this.props.getUserData(data);
        } else {
            const data = this.props.currentUser;
            data.country_code = countryCode;
            data.country_id = countryId;
            data.language_code = languageCode;
            data.language_id = languageId;
            data.time_zone = timezone;
            data.member_group_id = this.props.currentUser.member_group_id;
            // here is that the goup id problem
            this.props.getUserData(data);
        }
        let la = languageCode.replace("-", "_").toString().toLowerCase();
        localStorage.setItem("lang", la || "en");
        this.props.i18n.changeLanguage(la);

        import(`../../assets/images/flags/${countryCode}.webp`).then((image) => {
            this.setState({
                currentCountryImage: image.default,
                currentCountryShortCode: countryCode,
                currentLanguageCode: languageCode.toUpperCase(),
                timezone: timezone,
                openModal: false,
            });
        });

        const showBannerData = {};
        showBannerData.country_id = countryId;

        this.props.showBanner(showBannerData);

        localStorage.setItem("changeCountry", true);
        localStorage.removeItem('promosData');
        localStorage.removeItem('vipDetails');

        this.setState({
            reloadPage: true
        });
    };

    render() {
        const { t } = this.props;
        const img = this.imageImport(require.context("../../assets/images", false, /\.(png|jpe?g|svg|webp)$/));
        const flags = this.imageImport(require.context("../../assets/images/flags", false, /\.(png|jpe?g|svg|webp)$/));
        const christmas = this.imageImport(require.context("../../assets/images/home/christmas", false, /\.(png|jpe?g|svg|webp)$/));
        let ig = '';
        let whatsapp = '';
        let youtube = '';
        return (
            <Auxiliary>
                <footer className="position-relative">
                    {
                        this.state.currentEvent === "christmas" ? (
                            <img className="event-bottom-deco" src={christmas["bottom-bg-christmas.webp"]} alt="bottom-deco" />
                        ) : (
                            <></>
                        )
                    }
                    <div className="x-container-no-m">
                        <div className="footer-one">
                            <span>
                                {/* <p className="mb-3">{t("footer.payment-method")}</p> */}
                                <img src={img["fpx-logo.svg"]} alt="fpx-logo" />
                                <img src={img["tether.svg"]} alt="tether-logo" />
                                <img src={img["tng.svg"]} alt="tng-logo" />
                                <img src={img["boost.svg"]} alt="boost-logo" />
                                <img src={img["grabpay.svg"]} alt="grabpay-logo" />
                                <img src={img["duitnow.svg"]} alt="duitnow-logo" />
                                {/* <img src={img['eeziepay.svg']} alt="eezie-logo" /> */}
                            </span>
                            <NavLink to={{ pathname: "/" }}>
                                <span className="p-0">
                                    {/* <p className="mb-3">{t("footer.licenses")}</p> */}
                                    <span>
                                        <img src={img["pagcor.webp"]} alt="pagcor-logo" />
                                        <img src={img["fcl.webp"]} alt="fcl-logo" />
                                        <img src={img["ifm-logo.webp"]} alt="ifm-logo" />
                                    </span>
                                </span>
                            </NavLink>
                        </div>
                    </div>
                    {/* <hr /> */}
                    <div className="x-container-no-m">
                        <div className="footer-two">
                            <p>
                                {t("footer.content-1")}
                            </p>
                            <div className="btn-social">
                                <a href={`https://www.facebook.com/${process.env.REACT_APP_MERCHANT_FB}`} target="_blank" rel="noreferrer">
                                    <Icon icon="iconoir:facebook" />
                                </a>
                                {/* <Link to="https://twitter.com/x33asia?s=20" target="_blank" rel="noreferrer">
                  <Icon icon="uil:twitter-alt" />
                </Link> */}
                                <a href={`https://www.instagram.com/${ig}/`} target="_blank" rel="noreferrer">
                                    <Icon icon="uil:instagram" />
                                </a>
                                <a href={`https://www.youtube.com/channel/${youtube}`} target="_blank" rel="noreferrer">
                                    <Icon icon="uil:youtube-alt" />
                                </a>
                                <a href={`https://api.whatsapp.com/send?phone=${process.env.REACT_APP_MERCHANT_WHATSAPP?.replace(/[^\d]/g, '')}`} target="_blank" rel="noreferrer">
                                    <Icon icon="uil:whatsapp" />
                                </a>
                                {/* <Link to="https://t.me/x33asia/" target="_blank" rel="noreferrer">
                  <Icon icon="uil:telegram-alt" />
                </Link> */} 
                            <span></span>
                            <div
                                role="button"
                                className="language-select gap-2"
                                data-bs-toggle="modal"
                                data-bs-target="#selectCountry"
                                onClick={this.openChangeCountryModal}
                            >
                                <img src={flags[(this.props.currentUser.country_code) ? this.props.currentUser.country_code + ".webp" : this.state.currentCountryShortCode + ".png"]} alt="flags" />
                                <p className="ml-2">{(this.props.currentUser.language_code) ? this.props.currentUser.language_code.toUpperCase() : this.state.currentLanguageCode}</p>
                                <i className="arrow down btn-text-icon-gray" />
                            </div>
                        </div>                            
                        </div>
                        <hr />
                        <div className="footer-three">
                            <ul className="navbar-nav">
                                <li className="nav-item">
                                    <Link to={{ pathname: "/about-us" }} className="nav-link">
                                        {t("footer.about-us")}
                                    </Link>
                                </li>
                                <span></span>
                                <li className="nav-item">
                                    <Link to={{ pathname: "/contact-us" }} className="nav-link">
                                        {t("footer.contact-us")}
                                    </Link>
                                </li>                                       
                                <span></span>
                                <li className="nav-item">
                                    <Link to={{ pathname: "/info-centre" }} className="nav-link">
                                        {t("footer.faqs")}
                                    </Link>
                                </li>
                                <span></span>
                                <li className="nav-item">
                                    <Link to={{ pathname: "/info-centre" }} className="nav-link">
                                        {t("footer.tnc")}
                                    </Link>
                                </li>
                                <span></span>
                                <li className="nav-item">
                                    <Link to={{ pathname: "/responsible-gaming" }} className="nav-link">
                                        {t("footer.responsible-gaming")}
                                    </Link>
                                </li>                                                                                    
                            </ul>
                            <small>&#0169; Royal77 {moment().format("YYYY")}. {t("footer.all-right")}</small>
                        </div>
                    </div>

                    <div className="modal global-modal fade" id="selectCountry" tabIndex="-1" aria-labelledby="selectCountryLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered  modal-language-body">
                            <div className="modal-content">
                                <div className="modal-header">
                                    {/* <img src={img["global-language.svg"]} alt="language" /> */}
                                    <h5 className="modal-title text-uppercase" id="selectCountryLabel">
                                        {t("footer.region-language")}
                                    </h5>
                                    <Icon type="button" className="btn-close" icon="mdi:close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                {this.state.loading && (
                                    <div className="modal-body">
                                        <ul>
                                            {countries &&
                                                countries.map((countryVal, index) => {
                                                    return (
                                                        <li key={index}>
                                                            <div className="country">
                                                                <img src={countryVal.image} alt="my flags" />
                                                                <h6>{countryVal.countryName}</h6>
                                                            </div>
                                                            <div className="language">
                                                                {langArr &&
                                                                    langArr.map((langVal, idx) => {
                                                                        if (countryVal.countryCode === langVal.countryCode) {
                                                                            if (idx === 0 && this.props.currentUser.length === 0) {
                                                                                return (
                                                                                    <button
                                                                                        className="btn btn-gradient-blue"
                                                                                        key={idx}
                                                                                        onClick={(event) =>
                                                                                            this.changeCountryHandler(
                                                                                                event,
                                                                                                countryVal.countryCode,
                                                                                                countryVal.countryId,
                                                                                                langVal.languageId,
                                                                                                langVal.code,
                                                                                                langVal.timezone
                                                                                            )
                                                                                        }
                                                                                        data-bs-dismiss="modal"
                                                                                    >
                                                                                        {langVal.displayLanguageName}
                                                                                    </button>
                                                                                );
                                                                            }

                                                                            return (
                                                                                <button
                                                                                    className={`btn ${this.props.currentUser.language_id === langVal.languageId
                                                                                        ? "btn-gradient-blue"
                                                                                        : "btn-white"
                                                                                        }`}
                                                                                    key={idx}
                                                                                    onClick={(event) =>
                                                                                        this.changeCountryHandler(
                                                                                            event,
                                                                                            countryVal.countryCode,
                                                                                            countryVal.countryId,
                                                                                            langVal.languageId,
                                                                                            langVal.code,
                                                                                            langVal.timezone
                                                                                        )
                                                                                    }
                                                                                    data-bs-dismiss="modal"
                                                                                >
                                                                                    {langVal.displayLanguageName}
                                                                                </button>
                                                                            );
                                                                        } else {
                                                                            return null;
                                                                        }
                                                                    })}
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </footer>
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = (state) => {
    const { home, banner } = state;
    return {
        country_data: home.country_data,
        currentUser: state.currentUser.data,
        show_banner_data: banner.show_banner_data
    };
};

//Using the redux calling api methods
const mapDispatchToProps = {
    getCountry,
    getUserData,
    showBanner
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withNamespaces("translation")(PageFooter)));
